<template>
  <div class="'page-router-wrapper">
    <el-row>
      <el-col :span="24">
        <div class="grid-content" style="position: relative;">
          <div
            style="position: absolute;z-index:110;text-align:right;width:100%;padding-top:100px;padding-right:300px;">
            <a href="javascript:void(0);" style="color:#0000CC;" @click="changeLanguage('english')">English</a>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <a href="javascript:void(0);" style="color:#0000CC;" @click="changeLanguage('chinese')">中文</a>
          </div>
          <img style="z-index:100" :width="width" src="../assets/images/productlist/home1.jpg" />

        </div>
      </el-col>
    </el-row>
    <div style="font-size:25px;color:red;">
      您好，在线免费版本的配载、GMDSS、ECDIS、雷达等产品的登录接口已经关闭，后续不再提供免费服务！商务合作联系电话：0411-84978997
    </div>
    <el-row>
      <el-col :span="4">
        &nbsp;
      </el-col>
      <el-col :span="16">
        <h3 style="margin-top:10px;font-weight:bold;">
          {{language.filter(l=>l.tag==currentLanguage)[0].hdzlzx}}
        </h3>
        <div style="text-align: left;margin-top:20px;">
          <table class="table1" width="100%">
            <tr>
              <td colspan="5" style="text-align:left">
                <a href="http://www.zlonmarine.com/#/">
                  {{language.filter(l=>l.tag==currentLanguage)[0].fhsy}}
                </a> &nbsp;&nbsp;&nbsp;&nbsp;
                <!-- <a href="javascript:void(0);" @click="yjyfkclick">
                  {{language.filter(l=>l.tag==currentLanguage)[0].yjfk}} </a>-->
                <a href="javascript:void(0);" @click="register">
                  {{language.filter(l=>l.tag==currentLanguage)[0].zc}}
                </a>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <label style=" vertical-align: middle; font-size:25px;">
                  {{language.filter(l=>l.tag==currentLanguage)[0].znpz}}
                </label>
                <br />
                <label style="vertical-align: middle;  color:red; font-size:15px;">
                  {{language.filter(l=>l.tag==currentLanguage)[0].llqtj}}
                </label>
              </td>
              <td colspan="2">
              </td>
              <td>
              </td>
            </tr>
            <tr>
              <td>
                <img @click="gosmartload('BULK')" class="shoushi" src="../assets/images/productlist/sanhuo.jpg" />
              </td>
              <td>
                <h4 @click="gosmartload('BULK')" class="shoushi">
                  {{language.filter(l=>l.tag==currentLanguage)[0].shc}}
                </h4>
                <p @click="gosmartload('BULK')" class="shoushi">{{language.filter(l=>l.tag==currentLanguage)[0].xt}}：web
                </p>
              </td>
              <td style="border-right:1px solid #919191;padding-left:50px;"></td>
              <td style="padding-left:50px;">
                <img @click="gosmartload('TANKER')" class="shoushi" src="../assets/images/productlist/yehuo.png" />
              </td>
              <td>
                <h4 @click="gosmartload('TANKER')" class="shoushi">{{language.filter(l=>l.tag==currentLanguage)[0].yhc}}
                </h4>
                <p @click="gosmartload('TANKER')" class="shoushi">
                  {{language.filter(l=>l.tag==currentLanguage)[0].xt}}：web</p>
              </td>
            </tr>
            <tr>
              <td>
              </td>
              <td>
              </td>
              <td style="border-right:1px solid #919191;padding-left:50px; height:50px;"></td>
              <td>
              </td>
              <td>
              </td>
            </tr>
            <tr>
              <td>
                <img @click="gosmartload('CONTAINER')" class="shoushi"
                  src="../assets/images/productlist/jizhuang.jpg" />
              </td>
              <td>
                <h4 @click="gosmartload('CONTAINER')" class="shoushi">
                  {{language.filter(l=>l.tag==currentLanguage)[0].jzxc}}</h4>
                <p @click="gosmartload('CONTAINER')" class="shoushi">
                  {{language.filter(l=>l.tag==currentLanguage)[0].xt}}：web</p>
              </td>
              <td style="border-right:1px solid #919191;padding-left:50px;"></td>
              <td style="padding-left:50px;">
                <img @click="gosmartload('MPV')" class="shoushi" src="../assets/images/productlist/duoyongtu.jpg" />
              </td>
              <td>
                <h4 @click="gosmartload('MPV')" class="shoushi">{{language.filter(l=>l.tag==currentLanguage)[0].dytc}}
                </h4>
                <p @click="gosmartload('MPV')" class="shoushi">{{language.filter(l=>l.tag==currentLanguage)[0].xt}}：web
                </p>
              </td>
            </tr>

            <tr>
              <td>
              </td>
              <td>
              </td>
              <td style="border-right:1px solid #919191;padding-left:50px; height:50px;"></td>
              <td>
              </td>
              <td>
              </td>
            </tr>
            <tr>
              <td>
                <img @click="gosmartload('roro')" class="shoushi" src="../assets/images/productlist/qichetu.jpg" />
              </td>
              <td>
                <h4 @click="gosmartload('roro')" class="shoushi">
                  {{language.filter(l=>l.tag==currentLanguage)[0].roroship}}
                </h4>
                <p @click="gosmartload('roro')" class="shoushi">{{language.filter(l=>l.tag==currentLanguage)[0].xt}}：web
                </p>
              </td>
              <td style="border-right:1px solid #919191;padding-left:50px;"></td>
              <td style="padding-left:50px;">
                <img @click="gosmartload('ALL')" class="shoushi" src="../assets/images/productlist/duoyongtu.jpg" />
              </td>
              <td>
                <h4 @click="gosmartload('ALL')" class="shoushi">{{language.filter(l=>l.tag==currentLanguage)[0].sdcxpz}}
                </h4>
                <p @click="gosmartload('ALL')" class="shoushi">{{language.filter(l=>l.tag==currentLanguage)[0].xt}}：web
                </p>

              </td>
            </tr>
            <tr>
              <td>
              </td>
              <td>
              </td>
              <td style="border-right:1px solid #919191;padding-left:50px; height:50px;"></td>
              <td>
              </td>
              <td>
              </td>
            </tr>
            <tr>
              <td>
                <img @click="goeid" class="shoushi" src="../assets/images/productlist/jizhuang.jpg" />
              </td>
              <td>
                <h4 @click="goeid" class="shoushi">{{language.filter(l=>l.tag==currentLanguage)[0].wjjxxt}}</h4>
                <p @click="goeid" class="shoushi">{{language.filter(l=>l.tag==currentLanguage)[0].xt}}：web</p>
                <a href="javascript:void(0);" v-if="EDI_use_url!=''"
                  @click="popUp('EDI_use_url')">{{language.filter(l=>l.tag==currentLanguage)[0].sysm}}</a>
                &nbsp; &nbsp;
              </td>
              <td style="border-right:1px solid #919191;padding-left:50px;"></td>
              <td style="padding-left:50px;">
                <img @click="gosmartload('ORE 325000')" class="shoushi" src="../assets/images/productlist/ksc.jpg" />
              </td>
              <td>
                <h4 @click="gosmartload('ORE 325000')" class="shoushi">
                  {{language.filter(l=>l.tag==currentLanguage)[0].ORE}}
                </h4>
                <p @click="gosmartload('ORE 325000')" class="shoushi">
                  {{language.filter(l=>l.tag==currentLanguage)[0].xt}}：web
                </p>

              </td>
            </tr>

            <tr>
              <td colspan="5" style="padding-top:50px;">
                <label style="font-size:25px;">GMDSS</label>
              </td>
            </tr>
            <tr>
              <td>
                <img class="shoushi" src="static/img/gmdss.png" />
              </td>
              <td>
                <h4 class="shoushi">{{language.filter(l=>l.tag==currentLanguage)[0].gmdssonlie}}</h4>
                <p class="shoushi" style="height:10px;">{{language.filter(l=>l.tag==currentLanguage)[0].xt}}：exe</p>
                <font style="color:red;">{{language.filter(l=>l.tag==currentLanguage)[0].Minimum_resolution}}：1680*1050
                </font>
                <br />
                <a href="javascript:void(0);" v-if="gmds_use_url!=''"
                  @click="popUp('gmds_use_url')">{{language.filter(l=>l.tag==currentLanguage)[0].azsm}}</a> &nbsp;
                &nbsp;
                &nbsp;
                <a href="javascript:void(0);" v-if="gmds_ins_url!=''"
                  @click="download(gmds_ins_url)">{{language.filter(l=>l.tag==currentLanguage)[0].sysm}}</a> &nbsp;
                &nbsp;
                &nbsp;
                <!-- <a href="http://oss.zlonmarine.com/OnlineProduct/online/GMDSS/GMDSS%20Installation%20Package.zip"
                  download="">{{language.filter(l=>l.tag==currentLanguage)[0].xz}}</a> -->
              </td>
              <td style="border-right:1px solid #919191;padding-left:50px;"></td>
              <td style="padding-left:50px;">
                <!-- <img @click="gogmdss" class="shoushi" src="../assets/images/productlist/2.png" /> -->
              </td>
              <td>
                <!-- <h4 @click="gogmdss" class="shoushi">SAILOR 6222 VHF DSC</h4> -->
                <!-- <p @click="gogmdss" class="shoushi">{{language.filter(l=>l.tag==currentLanguage)[0].xt}}：web</p> -->
              </td>
            </tr>
            <tr>
              <td>
              </td>
              <td>
              </td>
              <td style="border-right:1px solid #919191;padding-left:50px; height:50px;"></td>
              <td>
              </td>
              <td>
              </td>
            </tr>
            <!-- <tr>
              <td>
                <img @click="gogmdss" class="shoushi" src="../assets/images/productlist/1.png" />
              </td>
              <td>
                <h4 @click="gogmdss" class="shoushi">SAILOR SP3520 VHF</h4>
                <p @click="gogmdss" class="shoushi">{{language.filter(l=>l.tag==currentLanguage)[0].xt}}：web</p>
              </td>
              <td style="border-right:1px solid #919191;padding-left:50px;"></td>
              <td style="padding-left:50px;">
              </td>
              <td>
              </td>
            </tr> -->

            <tr>
              <td colspan="5" style="padding-top:50px;">
                <label style="font-size:25px;">{{language.filter(l=>l.tag==currentLanguage)[0].zxxxxt}}</label>
              </td>
            </tr>

            <tr>
              <td>
                <img class="shoushi" src="static/imgts/khld.png" />
              </td>
              <td>
                <h4 class="shoushi">{{language.filter(l=>l.tag==currentLanguage)[0].jrcld}}</h4>
                <p class="shoushi">{{language.filter(l=>l.tag==currentLanguage)[0].xt}}：exe</p>
                <a href="javascript:void(0);" v-if="jrc_ins_url!=''"
                  @click="popUp('jrc_ins_url')">{{language.filter(l=>l.tag==currentLanguage)[0].azsm}}</a> &nbsp; &nbsp;

                <a href="javascript:void(0);" v-if="jrc_use_url!=''"
                  @click="popUp('jrc_use_url')">{{language.filter(l=>l.tag==currentLanguage)[0].sysm}}</a> &nbsp; &nbsp;

                <!-- <a href="http://oss.zlonmarine.com/OnlineProduct/online/JRCRADAR/JRC%20radar%20Installation%20Package.zip"
                  download="">{{language.filter(l=>l.tag==currentLanguage)[0].xz}}</a> -->
              </td>

              <td style="border-right:1px solid #919191;padding-left:50px;"></td>

              <td style="padding-left:50px;">
                <img class="shoushi" src="static/imgts/jrcld.png" />
              </td>
              <td>
                <h4 class="shoushi">{{language.filter(l=>l.tag==currentLanguage)[0].ld}}</h4>
                <p class="shoushi">{{language.filter(l=>l.tag==currentLanguage)[0].xt}}：exe</p>
                <a href="javascript:void(0);" v-if="hk_ins_url!=''"
                  @click="popUp('hk_ins_url')">{{language.filter(l=>l.tag==currentLanguage)[0].azsm}}</a>
                &nbsp; &nbsp;

                <a href="javascript:void(0);" v-if="hk_use_url!=''"
                  @click="popUp('hk_use_url')">{{language.filter(l=>l.tag==currentLanguage)[0].sysm}}</a>
                &nbsp; &nbsp;

                <!-- <a href="http://oss.zlonmarine.com/OnlineProduct/online/KHRADAR/KH%20radar%20Installation%20Package.zip"
                  download="">{{language.filter(l=>l.tag==currentLanguage)[0].xz}}</a> -->
              </td>
            </tr>
            <tr>
              <td>
              </td>
              <td>
              </td>
              <td style="border-right:1px solid #919191;padding-left:50px; height:50px;"></td>
              <td>
              </td>
              <td>
              </td>
            </tr>
            <tr>
              <td>
                <img class="shoushi" @click="dzht()" src="../assets/images/productlist/timg.jpg" />
              </td>
              <td>
                <h4 @click="dzht()" class="shoushi">{{language.filter(l=>l.tag==currentLanguage)[0].dzhtzxxxxt}}</h4>
                <p @click="dzht()" class="shoushi" style="height:10px;">
                  {{language.filter(l=>l.tag==currentLanguage)[0].xt}}：exe</p>
                <font style="color:red;">{{language.filter(l=>l.tag==currentLanguage)[0].Minimum_resolution}}：1280*1024
                </font>
                <br />
                <a href="javascript:void(0);" v-if="htsm_ins_url!=''"
                  @click="popUp('htsm_ins_url')">{{language.filter(l=>l.tag==currentLanguage)[0].azsm}}</a> &nbsp;
                &nbsp;
                &nbsp;
                <a href="javascript:void(0);" v-if="htsm_use_url!=''"
                  @click="popUp('htsm_use_url')">{{language.filter(l=>l.tag==currentLanguage)[0].sysm}}</a> &nbsp;
                &nbsp;
                &nbsp;
                <!-- <a href="http://oss.zlonmarine.com/OnlineProduct/online/ECDIS/ECDIS%20Installation%20Package.zip"
                  download="">{{language.filter(l=>l.tag==currentLanguage)[0].xz}}</a> -->
              </td>
              <td style="border-right:1px solid #919191;padding-left:50px;"></td>
              <td style="padding-left:50px;">
                <!-- @click="gojiujiang" -->
                <!-- <img @click="gojiujiang" class="shoushi" src="../assets/images/productlist/zaixian.jpg" /> -->
              </td>
              <td>
                <!-- <h4 @click="gojiujiang" class="shoushi">{{language.filter(l=>l.tag==currentLanguage)[0].xifz}}</h4>
                <p @click="gojiujiang" class="shoushi">{{language.filter(l=>l.tag==currentLanguage)[0].xt}}：web</p> -->
              </td>
            </tr>
            <tr>
              <td>
              </td>
              <td>
              </td>
              <td style="border-right:1px solid #919191;padding-left:50px; height:50px;"></td>
              <td>
              </td>
              <td>
              </td>
            </tr>

            <tr>
              <td colspan="5" style="padding-top:50px;">
                <label style="font-size:25px;">VR/AR</label>
              </td>
            </tr>
            <tr>
              <td>
                <img class="shoushi" src="static/imgts/vr3.png" />
              </td>
              <td>
                <h4 class="shoushi">{{language.filter(l=>l.tag==currentLanguage)[0].vrhz}}
                </h4>
                <p class="shoushi">
                  {{language.filter(l=>l.tag==currentLanguage)[0].xt}}：exe</p>

                <!-- <a href="javascript:void(0);"
                  @click="popUp('haiZhan/海大智龙南海海战软件V1.0_安装说明.pdf')">{{language.filter(l=>l.tag==currentLanguage)[0].azsm}}</a>
                &nbsp; &nbsp; -->
                <a href="javascript:void(0);" v-if="vrhz_use_url!=''"
                  @click="popUp('vrhz_use_url')">{{language.filter(l=>l.tag==currentLanguage)[0].sysm}}</a>
                &nbsp; &nbsp;
                <!-- <a href="http://oss.zlonmarine.com/OnlineProduct/haiZhan/海大智龙_VR海战演练.exe"
                  download="">{{language.filter(l=>l.tag==currentLanguage)[0].xz}}</a> -->
                &nbsp; &nbsp;
                <a href="javascript:void(0);" onclick="window.open('http://www.zlonmarine.com/haiZhan/')"
                  download="">{{language.filter(l=>l.tag==currentLanguage)[0].vrhzonline}}</a>
              </td>
              <td style="border-right:1px solid #919191;padding-left:50px; "></td>
              <td style="padding-left:50px;">
                <img class="shoushi" onclick="alert('近期上线,敬请期待！')" src="static/imgts/vr1.png" />
              </td>
              <td>
                <h4 onclick="alert('近期上线,敬请期待！')" class="shoushi">{{language.filter(l=>l.tag==currentLanguage)[0].vryt}}
                </h4>
                <p onclick="alert('近期上线,敬请期待！')" class="shoushi">
                  {{language.filter(l=>l.tag==currentLanguage)[0].xt}}：exe</p>

                <a href="javascript:void(0);" v-if="vryt_use_url!=''"
                  @click="popUp('vryt_use_url')">{{language.filter(l=>l.tag==currentLanguage)[0].sysm}}</a>
                &nbsp; &nbsp;
                <!-- <a
                  href="//oss.zlonmarine.com/OnlineProduct/vrar/youting/海大智龙游艇驾驶VR演练系统安装包.exe">{{language.filter(l=>l.tag==currentLanguage)[0].xz}}</a> -->
                &nbsp; &nbsp;
                <a href="javascript:void(0);" onclick="window.open('http://www.zlonmarine.com/youting/')"
                  download="">{{language.filter(l=>l.tag==currentLanguage)[0].vrhzonline}}</a>
              </td>
            </tr>


            <tr>
              <td style="padding-top:50px;">
                <img class="shoushi" src="static/imgts/vr2.png" />
              </td>
              <td style="padding-top:50px;">
                <h4 class="shoushi">{{language.filter(l=>l.tag==currentLanguage)[0].vrxf}}
                </h4>
                <p class="shoushi">
                  {{language.filter(l=>l.tag==currentLanguage)[0].xt}}：exe</p>
                <a href="javascript:void(0);" v-if="vrxf_use_url!=''"
                  @click="popUp('vrxf_use_url')">{{language.filter(l=>l.tag==currentLanguage)[0].sysm}}</a>
                &nbsp; &nbsp;
                <!-- <a href="http://oss.zlonmarine.com/OnlineProduct/vrar/xiaofang/海大智龙船舶消防VR演练系统安装包.exe"
                  download="">{{language.filter(l=>l.tag==currentLanguage)[0].xz}}</a> -->
              </td>
              <td style="border-right:1px solid #919191;padding-left:50px; padding-top:50px;"></td>
              <td style="padding-left:50px; padding-top:50px;">
                <img onclick="alert('近期上线,敬请期待！')" class="shoushi" src="static/imgts/vr4.png" />
              </td>
              <td style="padding-top:50px;">
                <h4 class="shoushi" onclick="alert('近期上线,敬请期待！')">
                  {{language.filter(l=>l.tag==currentLanguage)[0].vrxnjs}}</h4>
                <p class="shoushi" onclick="alert('近期上线,敬请期待！')">
                  {{language.filter(l=>l.tag==currentLanguage)[0].xt}}：exe</p>
              </td>
            </tr>

            <tr>
              <td style="padding-top:50px;">
                <img class="shoushi" src="static/imgts/vr5.png" />
              </td>
              <td style="padding-top:50px;">
                <h4 class="shoushi">
                  {{language.filter(l=>l.tag==currentLanguage)[0].vrjst}}</h4>
                <p class="shoushi">
                  {{language.filter(l=>l.tag==currentLanguage)[0].xt}}：exe</p>
                <a href="javascript:void(0);" v-if="vrjst_use_url!=''"
                  @click="popUp('vrjst_use_url')">{{language.filter(l=>l.tag==currentLanguage)[0].sysm}}</a>
                &nbsp; &nbsp;

                <!-- <a href="javascript:void(0);"
                  @click="popUp('ldczsm.pdf')">{{language.filter(l=>l.tag==currentLanguage)[0].sysm}}</a> &nbsp; &nbsp; -->

                <!-- <a href="http://oss.zlonmarine.com/OnlineProduct/vrar/jiushengtingfa/救生艇筏VR演练系统.exe"
                  download="">{{language.filter(l=>l.tag==currentLanguage)[0].xz}}</a> -->
              </td>
              <td style="border-right:1px solid #919191;padding-left:50px; padding-top:50px;"></td>
              <td style="padding-left:50px; padding-top:50px;">
                <img onclick="alert('近期上线,敬请期待！')" class="shoushi" src="static/imgts/vr6.png" />
              </td>
              <td style="padding-top:50px;">
                <h4 class="shoushi" onclick="alert('近期上线,敬请期待！')">
                  {{language.filter(l=>l.tag==currentLanguage)[0].vrjxl}}</h4>
                <p class="shoushi" onclick="alert('近期上线,敬请期待！')">
                  {{language.filter(l=>l.tag==currentLanguage)[0].xt}}：exe</p>
              </td>
            </tr>

            <tr>
              <td style="padding-top:50px;">
                <img onclick="alert('近期上线,敬请期待！')" class="shoushi" src="static/imgts/vr7.png" />
              </td>
              <td style="padding-top:50px;">
                <h4>{{language.filter(l=>l.tag==currentLanguage)[0].vrmb}}
                </h4>
                <p>
                  {{language.filter(l=>l.tag==currentLanguage)[0].xt}}：exe</p>
                <a href="javascript:void(0);" v-if="vrmb_use_url!=''"
                  @click="popUp('vrmb_use_url')">{{language.filter(l=>l.tag==currentLanguage)[0].sysm}}</a>
                &nbsp; &nbsp;

                <!-- <a href="http://oss.zlonmarine.com/OnlineProduct/vrar/maobo/船舶锚泊设备VR演练系统.exe"
                  download="">{{language.filter(l=>l.tag==currentLanguage)[0].xz}}</a> -->
                <!-- <a href="javascript:void(0);"
                  @click="popUp('ldsm.pdf')">{{language.filter(l=>l.tag==currentLanguage)[0].azsm}}</a> &nbsp; &nbsp;

                <a href="javascript:void(0);"
                  @click="popUp('ldczsm.pdf')">{{language.filter(l=>l.tag==currentLanguage)[0].sysm}}</a> &nbsp; &nbsp;

                <a href="http://oss.zlonmarine.com/OnlineProduct/%E9%9B%B7%E8%BE%BE%E5%AE%89%E8%A3%85%E5%8C%85.zip"
                  download="">{{language.filter(l=>l.tag==currentLanguage)[0].xz}}</a> -->
              </td>
              <td style="border-right:1px solid #919191;padding-left:50px;padding-top:50px; "></td>
              <td style="padding-left:50px; padding-top:50px;">
              </td>
              <td>
              </td>
            </tr>

            <tr>
              <td colspan="5" style="padding-top:50px;">
                <label style="font-size:25px;">{{language.filter(l=>l.tag==currentLanguage)[0].bp}}</label>
              </td>
            </tr>
            <tr>
              <td>
                <!-- @click="gojiujiang" -->
                <img @click="gojiujiang" class="shoushi" src="../assets/images/productlist/zaixian.jpg" />
              </td>
              <td>
                <h4 @click="gojiujiang" class="shoushi">{{language.filter(l=>l.tag==currentLanguage)[0].xifz}}</h4>
                <p @click="gojiujiang" class="shoushi">{{language.filter(l=>l.tag==currentLanguage)[0].xt}}：web</p>
              </td>
              <td style="border-right:1px solid #919191;padding-left:50px;"></td>
              <td style="padding-left:50px;">

              </td>
              <td>

              </td>
            </tr>

            <tr>
              <td colspan="5" style="padding-top:50px;">
                <label style="font-size:25px;">{{language.filter(l=>l.tag==currentLanguage)[0].qt}}</label>
              </td>
            </tr>
            <tr>
              <td>
                <img @click="nosrc" class="shoushi" src="../assets/images/productlist/kaoshi.jpg" />
              </td>
              <td>
                <h4 @click="nosrc" class="shoushi">{{language.filter(l=>l.tag==currentLanguage)[0].zxkspt}}</h4>
                <font style="color:red;">{{language.filter(l=>l.tag==currentLanguage)[0].cxtqddzc}}</font><br />
                <font @click="nosrc" class="shoushi">{{language.filter(l=>l.tag==currentLanguage)[0].xt}}：web</font>
                <br />
                <a href="javascript:void(0);" v-if="zxkspt_use_url!=''"
                  @click="popUp('zxkspt_use_url')">{{language.filter(l=>l.tag==currentLanguage)[0].sysm}}</a>
                &nbsp; &nbsp;
              </td>
              <td style="border-right:1px solid #919191;padding-left:50px;"></td>
              <td style="padding-left:50px;">
                <img @click="download" class="shoushi" style="height:100px;"
                  src="../assets/images/productlist/shouji.jpg" />
              </td>
              <td>
                <h4 @click="download" class="shoushi">{{language.filter(l=>l.tag==currentLanguage)[0].sjlxksxt}}</h4>
                <p @click="download" class="shoushi">{{language.filter(l=>l.tag==currentLanguage)[0].xt}}：android</p>
                <a href="javascript:void(0);" v-if="sjlxksxt_use_url!=''"
                  @click="popUp('sjlxksxt_use_url')">{{language.filter(l=>l.tag==currentLanguage)[0].sysm}}</a>
                &nbsp; &nbsp;

                <!-- <a href="http://oss.zlonmarine.com/OnlineProduct/Examination/android-debug.apk"
                  download="">{{language.filter(l=>l.tag==currentLanguage)[0].xz}}</a> -->
              </td>
            </tr>

            <tr>
              <td>
              </td>
              <td>
              </td>
              <td style="border-right:1px solid #919191;padding-left:50px; height:50px;"></td>
              <td>
              </td>
              <td>
              </td>
            </tr>

            <tr>
              <td>
                <img @click="ShowCpatcpa" class="shoushi" src="static/imgts/tcpa/1.png" />
              </td>
              <td>
                <h4 @click="ShowCpatcpa" class="shoushi"> DCPA/TCPA</h4>
              </td>
              <td style="border-right:1px solid #919191;padding-left:50px;"></td>
              <td style="padding-left:50px;">

              </td>
              <td>

              </td>
            </tr>
          </table>
          <br />
        </div>
      </el-col>
      <el-col :span="4">
        &nbsp;
      </el-col>
    </el-row>
    <div class="dialog">
      <el-dialog :title="language.filter(l=>l.tag==currentLanguage)[0].yjfk" :visible.sync="dialogVisible" width="800px"
        :close-on-click-modal="false" @close="handleCancelBtn">
        <el-form ref="dataPaper" size="small" :rules="rules" :model="paperInfo" label-position="right"
          label-width="130px">
          <el-form-item :label="language.filter(l=>l.tag==currentLanguage)[0].xysdh+'：'" prop="content">
            <el-input v-model="paperInfo.content" :rows="4" type="textarea" placeholder="what you want to say"
              maxlength="300">
            </el-input>
          </el-form-item>
          <el-form-item :label="language.filter(l=>l.tag==currentLanguage)[0].xm+'：'" prop="name">
            <el-input v-model="paperInfo.name" placeholder="please enter your name" maxlength="50"></el-input>
          </el-form-item>
          <el-form-item :label="language.filter(l=>l.tag==currentLanguage)[0].lxfs+'：'" prop="contact">
            <el-input v-model="paperInfo.contact" placeholder="(tel/email)" maxlength="50"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="handleCancelBtn">cancel</el-button>
          <el-button size="mini" type="primary" @click="handleSubmitBtn('dataPaper')">OK</el-button>
        </span>
      </el-dialog>
    </div>
    <cpatcpa :dialogVisible.sync="cpatcpaShow"></cpatcpa>
    <div class="div-xf" @mouseleave="leave">
      <div @mouseenter="enter()" @mousemove="updateXY" class=" suspension">联系我们</div>
      <div v-show="seen" class="hover_con">
        <br />
        <el-row>
          <el-col :span="18">
            <table width="100%" class="td-left">
              <tr>
                <td class="td-left">
                  <h5>联系我们</h5>
                </td>
                <td></td>
              </tr>
              <tr>
                <td class="td-left1" style="color:#3f9f00;">大连海大智龙科技有限公司</td>
                <td></td>
              </tr>
              <tr>
                <td class="td-left oboutfontsize"><span>地址: 大连市高新技术产业园区黄浦路523号海事科技大厦A座11层</span> </td>
                <td class="td-left"></td>
              </tr>
              <tr>
                <td class="td-left oboutfontsize">邮编：116023</td>
                <td></td>
              </tr>
              <tr>
                <td class="td-left oboutfontsize">电话：0411-84978997</td>
                <td></td>
              </tr>
              <tr>
                <td class="td-left oboutfontsize">公司邮箱：sales@zlonmarine.com </td>
                <td></td>
              </tr>
            </table>
          </el-col>
          <el-col :span="4">
            <a href="javascript:void(0);" @click="yjyfkclick">
              {{language.filter(l=>l.tag==currentLanguage)[0].yjfk}}</a>
          </el-col>
          <el-col :span="2"><i @click="leave" class="el-dialog__close el-icon el-icon-close"></i></el-col>
        </el-row>
        <div class="div-line  divcss5 div-bottom10 "></div>

        <el-row class="div-bottom10 ">
          <el-col :span="9">
            <table width="100%">
              <tr>
                <td class="td-left obouttopfontsize">ECDIS技术专家</td>

              </tr>
              <tr>
                <!-- <td class="td-left oboutfontsize">姓名:朱忠显</td> -->
              </tr>
              <tr>
                <td class="td-left oboutfontsize">邮箱:zhuzhongxian@zlonmarine.com</td>
              </tr>
            </table>
          </el-col>
          <el-col :span="3"><img class="img-ablout" src="static/img/about/zzx.png" /></el-col>
          <el-col :span="9">
            <table width="100%">
              <tr>
                <td class="td-left obouttopfontsize">配载技术专家</td>
              </tr>
              <tr>
                <!-- <td class="td-left oboutfontsize">姓名：刘春雷</td> -->
              </tr>
              <tr>
                <td class="td-left oboutfontsize">邮箱：liuchunlei@zlonmarine.com</td>
              </tr>
            </table>
          </el-col>
          <el-col :span="3"><img class="img-ablout" src="static/img/about/lcl.png" /></el-col>
        </el-row>

        <div class="div-line  divcss5 div-bottom10"></div>
        <el-row class="div-bottom10 ">
          <el-col :span="9">
            <table width="100%">
              <tr>
                <td class="td-left obouttopfontsize">雷达技术专家</td>

              </tr>
              <tr>
                <!-- <td class="td-left oboutfontsize">姓名:张东洋</td> -->

              </tr>
              <tr>
                <td class="td-left oboutfontsize">邮箱:zhangdongyang@zlonmarine.com</td>

              </tr>

            </table>
          </el-col>
          <el-col :span="3">
            <img class="img-ablout" src="static/img/about/zdy.png" />
          </el-col>
          <el-col :span="9">
            <table width="100%">
              <tr>
                <td class="td-left obouttopfontsize">GMDSS技术专家
                </td>
              </tr>
              <tr>
                <!-- <td class="td-left oboutfontsize">姓名：肖方兵</td> -->
              </tr>
              <tr>
                <td class="td-left oboutfontsize">邮箱：xiaofangbing@zlonmarine.com
                </td>
              </tr>
            </table>
          </el-col>
          <el-col :span="3">
            <!-- <img class="img-ablout" src="static/img/about/xfb.png" /> -->
          </el-col>
        </el-row>
        <div class="div-line  divcss5 div-bottom10"></div>
        <el-row class="div-bottom10 ">
          <el-col :span="9">
            <table width="100%">
              <tr>
                <td class="td-left obouttopfontsize">VR/AR技术专家
                </td>
              </tr>
              <tr>
                <!-- <td class="td-left oboutfontsize">姓名:刘晶晶</td> -->
              </tr>
              <tr>
                <td class="td-left oboutfontsize">邮箱:liujingjing@zlonmarine.com</td>
              </tr>
            </table>
          </el-col>
          <el-col :span="3">
            <img class="img-ablout" src="static/img/about/ljj.png" />
          </el-col>
          <el-col :span="9">
            <table width="100%">
              <tr>
                <td class="td-left obouttopfontsize">其他技术
                </td>
              </tr>
              <tr>
                <!-- <td class="td-left oboutfontsize">姓名：张克青</td> -->
              </tr>
              <tr>
                <td class="td-left oboutfontsize">邮箱：zhangkeqing@zlonmarine.com
                </td>
              </tr>
            </table>
          </el-col>
          <el-col :span="3">
            <img class="img-ablout" src="static/img/about/zkq.png" />
          </el-col>
        </el-row>
        <br />
      </div>
    </div>
  </div>
</template>

<script>
  import productdetailbanner from "@/components//contentcoms/prodecutcontentcoms/productdetailbanner";
  import cpatcpa from '@/components/CpaTcpa/cpatcpa'
  import axios from 'axios'
  import Vue from 'vue'
  export default {
    name: "producthlwhhjy",
    data() {
      return {
        cpatcpaShow: false,
        data_content: [],
        seen: false,
        x: 0,
        y: 0,
        positionStyle: {
          top: '20px',
          left: '20px'
        },
        paperInfo: {
          content: "",
          name: "",
          contact: ""
        },
        rules: {
          content: [{
            required: true,
            message: "Please enter what you want to say",
            trigger: "change"
          }],
          name: [{
            required: true,
            message: "Please enter your name",
            trigger: "change"
          }],
          contact: [{
            required: true,
            message: "Please enter your contact",
            trigger: "change"
          }]
        },
        width: '0px',
        currentLanguage: 'chinese',
        dialogVisible: false,
        title: "意见&反馈",
        language: [{
          xysdh: "想要说的话",
          xm: '姓名',
          lxfs: '联系方式',
          bp: '在线避碰虚拟仿真平台',
          tag: 'chinese',
          sjlxksxt: '手机练习考试系统',
          xt: '系统',
          xz: '下载',
          sysm: '使用说明',
          azsm: '安装说明',
          zxkspt: '在线考试平台',
          dzhtzxxxxt: '电子海图在线学习',
          cxtqddzc: '此系统请单独注册',
          ld: 'KH雷达',
          jrcld: 'JRC雷达',
          xl: '系列',
          wjjxxt: 'edi文件解析系统',
          sdcxpz: '五大船型配载',
          dytc: '多用途船配载',
          jzxc: '集装船配载',
          yhc: '液货船配载',
          shc: '散货船配载',
          qt: '其他',
          zc: '注册',
          fhsy: '返回首页',
          hdzlzx: '海大智龙在线实操训练平台',
          znpz: '智能配载',
          llqtj: '浏览器推荐(谷歌浏览器、火狐浏览器),1920 x 1080(推荐)',
          zxxxxt: '雷达和海图',
          xifz: '虚拟仿真实训平台',
          gmdssonlie: 'GMDSS在线学习系统',
          vrhzonline: '在线体验',
          vryt: '游艇驾驶VR演练系统',
          vrhz: '海战VR演练系统',
          vrxf: '船舶消防VR演练系统',
          vrxnjs: '船舶虚拟驾驶演练系统',
          vrjst: '救生/救助艇VR演练系统',
          vrjxl: '船舶系缆设备VR演练系统',
          vrmb: '船舶锚泊设备VR演练系统',
          yjfk: '意见&反馈',
          roroship: "汽车船",

          Minimum_resolution: "最小分辨率",
          ORE: "矿砂船"
        }, {
          lxfs: 'contact',

          bp: 'Online learnging system for ship collision avoidance',
          xysdh: "want to say",
          xm: 'name',
          yjfk: 'Feedback',
          tag: 'english',
          sjlxksxt: 'Mobile examination system(for android)',
          xt: 'system',
          xz: 'download',
          sysm: 'user manual',
          azsm: 'installation help',
          zxkspt: 'Online examination',
          dzhtzxxxxt: 'ECDIS',
          cxtqddzc: 'Need to register separately',
          ld: 'KH Radar',
          jrcld: 'JRC Radar',
          xl: 'series',
          wjjxxt: 'EDI online viewer',
          sdcxpz: 'All loading computers',
          dytc: 'MPV loading computer',
          jzxc: 'Container loading computer',
          yhc: 'Tanker loading computer',
          shc: 'Bulk carrier loading computer',
          qt: 'Others',
          zc: 'Register',
          fhsy: 'Home',
          hdzlzx: 'Online Training Platform of Zlon Marine',
          znpz: 'Loading Computers(web)',
          llqtj: 'Please use Google chrome or Firefox browser(1920 x 1080)',
          zxxxxt: 'Radar And Electronic Charting ',
          xifz: 'ship collision avoidance',
          gmdssonlie: 'GMDSS',
          vryt: 'Yacht training system',
          vrhzonline: 'online',
          vrhz: 'Sea battle training system',
          vrxf: 'Fire-fighting training system',
          vrxnjs: 'Virtual ship training system',
          vrjst: 'Survival craft and rescue boats training system',
          vrjxl: 'Ship mooring equipment training system',
          vrmb: 'Ship anchoring equipment training system',
          roroship: "ROROShip",
          Minimum_resolution: "Minimum resolution",
          ORE: "ORE 325000"

        }],
        EDI_use_url: "",
        gmds_use_url: "",
        gmds_ins_url: "",
        jrc_use_url: "",
        jrc_ins_url: "",
        htsm_use_url: "",
        htsm_ins_url: "",
        hk_ins_url: "",
        hk_use_url: "",
        vrhz_use_url: "",
        vryt_use_url: "",
        vrxf_use_url: "",
        vrjst_use_url: "",
        vrmb_use_url: "",
        zxkspt_use_url: "",
        sjlxksxt_use_url: ""

      }
    },
    created() {
      this.listenerFunction()

    },

    methods: {
      ShowCpatcpa() {
        this.cpatcpaShow = true
      },
      // 事件监听 监听页面的 scroll 事件，回调方法为 handleScroll
      listenerFunction(e) {
        document.addEventListener('scroll', this.handleScroll, true)
      },
      // 编写滚动条事件
      handleScroll() {
        // 获取滚动条元素对象
        // let ele = document.getElementsByClassName('page-router-wrapper')[0]
        // // 获取需要固定的元素对象
        // let editorNav = document.getElementsByName('n_my_editor_nav')[0]
        // // 判断滚动条的高度（大于240，给固定元素添加 class）
        // if (ele.scrollTop > 240) {
        //   editorNav.classList.add('suspension')
        // } else {
        //   editorNav.classList.remove('suspension')
        // }
      },

      enter() {

        this.seen = true;

      },
      leave: function () {
        this.seen = false;
      },
      updateXY: function (event) {
        this.x = event.pageX;
        this.y = event.pageY;
        // this.positionStyle={top: this.y-100 + 'px',left: this.x-374 + 'px'};
      },

      changeLanguage(language) {
        this.currentLanguage = language

        this.Languageurl()

      },

      Languageurl() {

        let basetConfig = Vue.prototype.baseConfig
        console.log(basetConfig)

        if (this.currentLanguage == 'chinese') {
          this.EDI_use_url = basetConfig[0].EDI_use_url
          this.gmds_use_url = basetConfig[0].gmds_use_url
          this.gmds_ins_url = basetConfig[0].gmds_ins_url
          this.jrc_use_url = basetConfig[0].jrc_use_url
          this.jrc_ins_url = basetConfig[0].jrc_ins_url
          this.htsm_use_url = basetConfig[0].htsm_use_url
          this.htsm_ins_url = basetConfig[0].htsm_ins_url
          this.vrhz_use_url = basetConfig[0].vrhz_use_url
          this.vryt_use_url = basetConfig[0].vryt_use_url
          this.vrxf_use_url = basetConfig[0].vrxf_use_url
          this.vrjst_use_url = basetConfig[0].vrjst_use_url
          this.vrmb_use_url = basetConfig[0].vrmb_use_url
          this.zxkspt_use_url = basetConfig[0].zxkspt_use_url
          this.sjlxksxt_use_url = basetConfig[0].sjlxksxt_use_url
          this.hk_ins_url = basetConfig[0].hk_ins_url
          this.hk_use_url = basetConfig[0].hk_use_url
        } else {
          this.EDI_use_url = basetConfig[1].EDI_use_url
          this.gmds_use_url = basetConfig[1].gmds_use_url
          this.gmds_ins_url = basetConfig[1].gmds_ins_url
          this.jrc_use_url = basetConfig[1].jrc_use_url
          this.jrc_ins_url = basetConfig[1].jrc_ins_url
          this.htsm_use_url = basetConfig[1].htsm_use_url
          this.htsm_ins_url = basetConfig[1].htsm_ins_url
          this.vrhz_use_url = basetConfig[1].vrhz_use_url
          this.vryt_use_url = basetConfig[1].vryt_use_url
          this.vrxf_use_url = basetConfig[1].vrxf_use_url
          this.vrjst_use_url = basetConfig[1].vrjst_use_url
          this.vrmb_use_url = basetConfig[1].vrmb_use_url
          this.zxkspt_use_url = basetConfig[1].zxkspt_use_url
          this.sjlxksxt_use_url = basetConfig[1].sjlxksxt_use_url
          this.hk_ins_url = basetConfig[1].hk_ins_url
          this.hk_use_url = basetConfig[1].hk_use_url
        }
      },


      goeid() {
        window.open('http://39.105.117.173:7071/#/');
      },
      gogmdss() {
        window.open('http://39.105.117.173:7080/#/');
      },
      gosmartload(type) {
        window.open('http://39.105.117.173:7070/#/?type=' + type);
      },
      gojiujiang() {
        window.open('http://39.105.117.173:8090//?page_id=142');
      },
      nosrc() {
        window.open('http://39.105.117.173:6061/#/');
      },
      yjyfkclick() {
        this.dialogVisible = true;
        this.seen = false;
      },

      // 保存信息操作按钮
      handleSubmitBtn() {
        this.$refs['dataPaper'].validate(valid => {
          if (valid) {
            axios.post("http://39.105.117.173:8001/LoginCheck/fankui", this.paperInfo)
              .then(res => {
                if (res.data.status == 0) {
                  alert('反馈成功!')
                  this.paperInfo.content = ''
                  this.paperInfo.name = ''
                  this.paperInfo.contact = ''
                  this.dialogVisible = false;
                }
              })
              .catch(error => {
                alert("发生错误" + error);
                this.dialogVisible = false;
              });
          } else {
            return false;
          }
        })
      },
      handleCancelBtn() {
        this.paperInfo.content = ''
        this.paperInfo.name = ''
        this.paperInfo.contact = ''
        this.dialogVisible = false;
      },
      popUp(winURL) {

        let basetConfig = Vue.prototype.baseConfig
        let url = ""
        if (this.currentLanguage == 'chinese') {
          url = basetConfig[0][winURL]
        } else {
          url = basetConfig[1][winURL]
        }
        const {
          href
        } = this.$router.resolve({
          // eslint-disable-next-line indent
          name: 'pdf',
          query: {
            winURL: 'http://oss.zlonmarine.com/OnlineProduct/' + url
          }
        })
        window.open(href)
      },
      register() {
        window.open("http://39.105.117.173:7070/#/register?flag=1")
      },

      dzht() {
        //window.location.href = 'http://121.36.151.90:8080/static/海大智龙ECDIS安装包.zip'
      },
      download(val) {
        console.log(val)
        window.location.href = val
      }
    },
    components: {
      productdetailbanner,
      cpatcpa
    },
    mounted() {

      window.onresize = () => {
        return (() => {
          this.width = $(window).width() + 'px';
        })();
      };
      setTimeout(() => {
        this.Languageurl()
      }, 1000);


    },
    beforeMount: function () {
      this.width = $(window).width() + 'px';
    },
    // 销毁事件监听
    beforeDestroy() {
      document.removeEventListener('scroll', this.listenerFunction)
    }
  }

</script>

<style scoped>
  div table {
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  }

  .shuli {
    position: absolute;
    margin: 0 auto;
    width: 20px;
    line-height: 24px;
    border: 1px solid #333
  }

  .hover_con {

    float: left;
    top: 500px;
    width: 800px;
    cursor: pointer;
    z-index: 99999;
    position: fixed;
    box-shadow: 0 6px 12px 0 rgba(0, 0, 0, .15);
    background-color: #fff;
  }

  .img-ablout {
    float: left;
    vertical-align: middle;
    width: 50px;
    height: 50px;
  }

  .div-xf {
    float: right;
    top: 500px;
    width: 830px;
    right: 5%;
    cursor: pointer;
    z-index: 99999;
    position: fixed;

  }

  .suspension {
    float: right;
    right: 0%;
    width: 25px;
    box-shadow: 0 6px 12px 0 rgba(0, 0, 0, .15);
    background-color: #fff;
  }

  .table1 td img {
    width: 150px;
    height: 100PX;
  }

  .td-left {

    padding-left: 15px;
    float: left;
    /* color: #090909; */
  }

  .obouttopfontsize {
    font-size: 15px;
  }

  .oboutfontsize {

    font-size: 13px;
  }

  .td-left1 {
    padding-left: 15px;
    float: left;
  }

  .shoushi {
    cursor: pointer;
  }

  h4 {
    font-size: 24px;
    color: #090909;
  }

  p {
    font-size: 16px;
    color: #919191;
  }

  /*********dialog*************/
  .dialog .el-dialog__header {
    padding: 10px;
    border-top: 4px solid #028bfe;
    border-bottom: 1px solid #eee;
  }

  .dialog .el-dialog__title {
    line-height: 24px;
    font-size: 15px;
    color: #333;
  }

  .dialog .el-dialog__body {
    font-size: 15px;
    color: #333;
    padding: 30px 80px;
  }

  .dialog .el-dialog__footer {
    padding: 10px;
    text-align: center;
    background-color: #edf5fe;
  }

  .div-line {
    background: #E6E6E6;
    height: 1px;
    width: 100%;

  }

  .div-bottom10 {
    margin-top: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/webproductlist.vue